<template>
  <div>
    <HotelTopNavbar />
    <block :height="80" />
    <div class="ga-container fluid mb-4 mb-lg-5 bg-white">
      <!-- HOTEL IMAGE -->
      <div class="w-100" v-if="getMerchant.merchant_images.length > 0">
        <div class="row slim-grid-row-1">
          <div class="col-12" v-if="getMerchant.merchant_images.length < 4">
            <div class="w-100 position-relative">
              <div
                v-if="getMerchant.merchant_images.length == 1"
                class="w-100 h-400">
                <img
                  :src="getMerchant.merchant_images[0].image_url"
                  class="img-fit cursor-pointer h-400 radius-8"
                  :alt="getMerchant.name" />
              </div>
              <flickity v-else ref="flickity" :options="$fullSliderOption">
                <div
                  class="carousel-cell w-100"
                  :id="slider_merchant.id"
                  v-for="slider_merchant in getMerchant.merchant_images">
                  <div class="w-100 h-400">
                    <img
                      :src="slider_merchant.image_url"
                      class="img-fit h-400 radius-8 cursor-pointer"
                      :alt="getMerchant.name" />
                  </div>
                </div>
              </flickity>

              <button
                v-if="getMerchant.merchant_images.length > 1"
                @click="selectMerchantImageIndex(0)"
                type="button"
                class="g-btn bg-white g-btn-sm px-2 cursor-pointer button-more-image rounded">
                {{ $t('general.view-all') }} ({{
                  getMerchant.merchant_images.length
                }})
              </button>
            </div>
          </div>
          <template v-else>
            <div class="col-xl-8 col-6 col-sm-7">
              <img
                :src="getMerchant.merchant_images[0].image_url"
                class="w-100 img-slider-1 h-400 cursor-pointer"
                :alt="getMerchant.name" />
            </div>
            <div class="col-xl-4 col-6 col-sm-5 h-400 overflow-hidden">
              <div class="row slim-grid-row-1">
                <div class="col-12 mb-2">
                  <div class="row slim-grid-row-1">
                    <div class="col-6">
                      <img
                        :src="getMerchant.merchant_images[1].image_url"
                        class="w-100 img-slider-2 cursor-pointer"
                        :alt="getMerchant.name" />
                    </div>
                    <div class="col-6">
                      <img
                        :src="getMerchant.merchant_images[2].image_url"
                        class="w-100 img-slider-3 cursor-pointer"
                        :alt="getMerchant.name" />
                    </div>
                  </div>
                </div>
                <div class="col-12 position-relative">
                  <img
                    :src="getMerchant.merchant_images[3].image_url"
                    class="w-100 img-slider-4 cursor-pointer"
                    :alt="getMerchant.name" />
                  <button
                    v-if="getMerchant.merchant_images.length > 4"
                    type="button"
                    class="g-btn bg-white g-btn-sm px-2 cursor-pointer button-more-image rounded">
                    {{ $t('general.view-all') }} ({{
                      getMerchant.merchant_images.length
                    }})
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <iframe
      src="https://local-group-merchant.guestpro.co.id/property/the-uma-desa?page_type=iframe"
      width="100%"
      style="height: 100vh !important"
      frameborder="0"></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HotelTopNavbar from '../hotel/HotelTopNavbar.vue';
export default {
  components: {
    HotelTopNavbar,
  },
  computed: {
    ...mapGetters(['getMerchant']),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/general/testIframePage.vue